import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-followup-element-dialog',
    templateUrl: './followup-element-dialog.component.html',
    styleUrls: ['./followup-element-dialog.component.scss'],
    standalone: false
})
export class FollowUpElementDialogComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<FollowUpElementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {}

  ngOnInit() {
     // This method is not implemented
  }

  followUp() {
    this.dialogRef.close(true);
  }

}
